/* eslint-disable */
const {
	timelineGap,
	timelineTopMargin,
	timelineGapMobile,
	timelineTopMarginMobile,
} = require('!!sass-variable-loader!./_style.scss');
/* eslint-enable */
const { stuttering, default: onWidthResize } = require('util/onWidthResize');
const asyncImport = require('util/asyncImport').default;

const {
	default: { slowDelay, breakMedium },
} = require('util/sass-variables');
const {
	getNumber,
	mediaQueryMin,
	trackGtm,
	trackGtm4,
} = require('util/functions');
const duration = getNumber(slowDelay) * 1000;

const INACTIVE = 'inactive';
const ACTIVE = 'active';

module.exports = {
	async init() {
		this.title = this.root.querySelector('.timeline-widget--title');
		this.steps = Array.from(this.root.querySelectorAll('.step'));
		this.baseDescription = this.root.querySelector(
			'.timeline-widget--step-description',
		);
		this.stepsLine = this.root.querySelector('.timeline-widget--steps');
		this.dots = this.root.querySelectorAll('.carousel-dot');
		this.previousButton = this.root.querySelector('.timeline-widget--previous');
		this.nextButton = this.root.querySelector('.timeline-widget--next');
		this.baseStep = this.steps[0];
		this.current = 0;
		await asyncImport(this, 'Hammer');
		this.touch = new this.Hammer(this.root);
		this.initEvents();
		this.resize();
	},
	initEvents() {
		this.steps.forEach((step, i) => {
			step.addEventListener('click', () => {
				this.updateIndex(i);
				this.gtm4Tracking(this.title);
			});
		});
		this.previousButton.addEventListener('click', () => {
			this.updateIndex(this.current - 1);
			this.gtm4Tracking(this.title);
		});
		this.nextButton.addEventListener('click', () => {
			this.updateIndex(this.current + 1);
			this.gtm4Tracking(this.title);
		});
		this.touch.on('swipeleft', () => {
			this.updateIndex(this.current + 1);
			this.gtm4Tracking(this.title);
		});
		this.touch.on('swiperight', () => {
			this.updateIndex(this.current - 1);
			this.gtm4Tracking(this.title);
		});
		this.gtmTracking();
		onWidthResize(this.resize.bind(this), stuttering.DEBOUNCE, 10);
	},
	getSteps() {
		let stepTitle;
		let stepNumber;
		this.steps.forEach((step, i) => {
			if (step.classList.contains('active')) {
				stepTitle = step.querySelector('.step--title').innerText.trim();
				stepNumber = i + 1;
			}
		});
		const stepObject = {
			title: stepTitle,
			number: stepNumber,
		};
		return stepObject;
	},
	gtm4Tracking(title) {
		const stepObject = this.getSteps();
		trackGtm4({
			event: 'GA4_event_c_timeline',
			widget_name: 'V3-Timeline-widget',
			widget_title: title ? title.innerText.trim() : 'No title',
			timeline_widget_step_number: stepObject.number
				? stepObject.number
				: 'undefined',
			timeline_widget_step_title: stepObject.title
				? stepObject.title
				: 'No title',
		});
	},
	resize() {
		this.mobile = !mediaQueryMin(breakMedium);
		const [stepsWidth, stepsHeight] = this.getStepsLargestSizes();
		this.setSpacingsBetweenSteps(stepsWidth);
		const spacing = getNumber(
			this.mobile ? timelineTopMarginMobile : timelineTopMargin,
		);
		const margin = stepsHeight + spacing;
		this.stepsLine.style.marginTop = margin + 'px';
		this.switchToStep(this.current);
	},
	setSpacingsBetweenSteps(stepsWidth) {
		this.timelineSpace = ((stepsWidth + 50) / this.stepsLine.clientWidth) * 100;
		this.steps.forEach((step, i) => {
			const margin = this.timelineSpace / 2 + '%';
			if (i)
				// first one should keep its 50% margin on left
				step.style.marginLeft = margin;
			step.style.marginRight = margin;
		});
		if (this.mobile) this.timelineGap = timelineGapMobile;
		else this.timelineGap = timelineGap;
	},
	// get the margin to scroll the steps to a certain one
	getIndexPosition(i) {
		const percent = 50 - i * this.timelineSpace - (i ? this.timelineGap : 0);
		return percent;
	},
	getStepsLargestSizes() {
		let hMax = 0;
		let wMax = 0;
		this.steps.forEach(step => {
			const content = step.querySelector('.step--content');
			const height = content.clientHeight;
			const width = content.clientWidth;
			if (hMax < height) hMax = height;
			if (wMax < width) wMax = width;
		});
		return [wMax, hMax];
	},
	// check index overflow, wrap if needed and switch to new step
	updateIndex(i) {
		let newIndex = i;
		const max = this.steps.length - 1;
		if (i < 0) newIndex = max;
		if (i > max) newIndex = 0;

		if (newIndex === 0) this.previousButton.classList.add(INACTIVE);
		else this.previousButton.classList.remove(INACTIVE);
		if (newIndex === max) this.nextButton.classList.add(INACTIVE);
		else this.nextButton.classList.remove(INACTIVE);
		this.switchToStep(newIndex);
		this.gtmTracking();
	},
	// ungrey step and add margins
	setStepActivation(step, active) {
		const margin =
			(this.timelineSpace + (active ? this.timelineGap * 2 : 0)) / 2 + '%';
		step.classList[active ? 'add' : 'remove'](ACTIVE);
		step.style.marginLeft = margin;
		step.style.marginRight = margin;
	},
	switchToStep(index) {
		const oldStep = this.steps[this.current];
		const newStep = this.steps[index];
		const oldDot = this.dots[this.current];
		const newDot = this.dots[index];
		const space = Math.abs(this.current - index);
		const to = this.getIndexPosition(index);

		// evaluate the animation delay
		let delay = (duration * space) / 1000;
		if (delay > 1.25) delay = 1.25;
		delay += 's';

		// set and unset steps
		this.setStepActivation(oldStep, false);
		this.setStepActivation(newStep, true);
		oldDot.classList.remove(ACTIVE);
		newDot.classList.add(ACTIVE);

		// position and time steps animation
		this.baseStep.style.marginLeft = to + '%';
		this.baseDescription.style.marginLeft = -index * 200 + '%';
		this.baseStep.style.transitionDuration = delay;
		this.baseDescription.style.transitionDuration = delay;
		this.current = index;
	},
	gtmTracking() {
		const { steps, current, title } = this;
		const currentStep = steps[current];
		const stepTitle = currentStep.querySelector('.step--title').textContent;
		trackGtm({
			eventCategory: 'timeline',
			eventAction: title ? title.textContent : 'Main title is not set',
			eventLabel: `${current} | ${stepTitle}`,
		});
	},
};
